export default __webpack_public_path__ + "static/media/NB-IOT-VOC.72e08568.png";